// International 14 major allergens required to be declared on food labels
// (EU FIC Regulation 1169/2011 · FDA FALCPA + FASTER Act 2021 · Codex Alimentarius).
export const ALLERGY_PRESETS = [
  { key: "gluten",     label: "Gluten",       emoji: "🌾", ingredients: ["wheat", "rye", "barley", "oats", "bread", "pasta", "spelt", "kamut"] },
  { key: "crustacean", label: "Crustaceans",  emoji: "🦐", ingredients: ["shrimp", "prawn", "crab", "lobster", "crayfish", "langoustine"] },
  { key: "egg",        label: "Eggs",         emoji: "🥚", ingredients: ["egg"] },
  { key: "fish",       label: "Fish",         emoji: "🐟", ingredients: ["salmon", "tuna", "cod", "haddock", "anchovy", "sardine", "fish"] },
  { key: "peanut",     label: "Peanuts",      emoji: "🥜", ingredients: ["peanut"] },
  { key: "soy",        label: "Soybeans",     emoji: "🫘", ingredients: ["soy", "soya", "soybean", "tofu", "edamame", "tempeh", "miso"] },
  { key: "dairy",      label: "Milk",         emoji: "🥛", ingredients: ["milk", "cheese", "butter", "yogurt", "cream", "whey", "casein", "ghee"] },
  { key: "tree-nut",   label: "Tree nuts",    emoji: "🌰", ingredients: ["almond", "walnut", "cashew", "pistachio", "pecan", "hazelnut", "macadamia", "brazil nut"] },
  { key: "celery",     label: "Celery",       emoji: "🥬", ingredients: ["celery", "celeriac"] },
  { key: "mustard",    label: "Mustard",      emoji: "🌭", ingredients: ["mustard"] },
  { key: "sesame",     label: "Sesame",       emoji: "🌱", ingredients: ["sesame", "tahini"] },
  { key: "sulphite",   label: "Sulphites",    emoji: "🧪", ingredients: ["sulphite", "sulfite", "sulphur dioxide", "sulfur dioxide"] },
  { key: "lupin",      label: "Lupin",        emoji: "🌼", ingredients: ["lupin", "lupine"] },
  { key: "mollusc",    label: "Molluscs",     emoji: "🦪", ingredients: ["mollusc", "mollusk", "oyster", "mussel", "clam", "squid", "octopus", "scallop", "snail"] },
];

const PRESET_BY_KEY = Object.fromEntries(ALLERGY_PRESETS.map(p => [p.key, p]));

/**
 * Given a list of ingredient name strings (or {name} objects), return the sorted list of
 * matched allergen presets (as {key,label,emoji,matched:[ingredient]}).
 */
export function detectAllergens(ingredients) {
  const names = (ingredients || [])
    .map(i => (typeof i === "string" ? i : (i?.name || "")).toLowerCase().trim())
    .filter(Boolean);
  const out = [];
  for (const preset of ALLERGY_PRESETS) {
    const matched = new Set();
    for (const n of names) {
      for (const kw of preset.ingredients) {
        if (n.includes(kw)) { matched.add(n); break; }
      }
    }
    if (matched.size) {
      out.push({ key: preset.key, label: preset.label, emoji: preset.emoji, matched: Array.from(matched) });
    }
  }
  return out;
}

export { PRESET_BY_KEY };
